import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import {AppDispatchType, ReduxStateType} from "./services/DataStore";

// use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatchType = useDispatch
export const useAppSelector: TypedUseSelectorHook<ReduxStateType> = useSelector
